import { render } from "./ContentBox.vue?vue&type=template&id=78766c44&scoped=true&ts=true"
import script from "./ContentBox.vue?vue&type=script&lang=ts"
export * from "./ContentBox.vue?vue&type=script&lang=ts"

import "./ContentBox.vue?vue&type=style&index=0&id=78766c44&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78766c44"]])

export default __exports__